import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PATHS } from "@/config/paths";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "@/hooks/useTranslation";

export const Route = createFileRoute("/_home/authError")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <div className="col-span-12 flex items-center justify-center py-12">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-center">{t("auth_error.title")}</CardTitle>
          <CardDescription className="text-center">{t("auth_error.description")}</CardDescription>
        </CardHeader>
        <CardContent className="pt-0 space-y-4">
          <p className="text-muted-foreground">{t("auth_error.problem_description")}</p>
          <ul className="list-disc pl-6 text-muted-foreground space-y-1">
            <li>{t("auth_error.reason_session_expired")}</li>
            <li>{t("auth_error.reason_provider_unavailable")}</li>
            <li>{t("auth_error.reason_permission_denied")}</li>
            <li>{t("auth_error.reason_network_issue")}</li>
          </ul>
          <p className="text-muted-foreground">{t("auth_error.help_text")}</p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-2">
          <Button asChild className="w-full">
            <Link to={PATHS.HOME}>{t("auth_error.go_home")}</Link>
          </Button>
          <Button variant="outline" asChild className="w-full">
            <Link to={PATHS.CONTACT}>{t("auth_error.contact_support")}</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
